import { MaterialIcon } from "@website/icons/material";
import { MonthActionsPropertiesType } from "@website/ui/datepicker/components/month-actions/month-actions.types";

export const useMonthActions = (properties: MonthActionsPropertiesType) => {
  const {
    calendarLocale,
    showPreviousMonth,
    showNextMonth,
    nextMonthDisabled,
    previousMonthDisabled
  } = properties;

  return {
    showPreviousMonthButtonProperties: {
      onClick: showPreviousMonth,
      EndIcon: <MaterialIcon name="chevron_left" variant="outlined" />,
      color: "neutral" as const,
      size: "small" as const,
      variant: "text" as const,
      "aria-label":
        calendarLocale === "persian" ? "نمایش ماه قبل" : "show-previous-month",
      equalDimension: true,
      disabled: previousMonthDisabled
    },
    showNextMonthButtonProperties: {
      onClick: showNextMonth,
      EndIcon: <MaterialIcon name="chevron_right" variant="outlined" />,
      color: "neutral" as const,
      size: "small" as const,
      variant: "text" as const,
      "aria-label":
        calendarLocale === "persian" ? "نمایش ماه بعد" : "show-next-month",
      equalDimension: true,
      disabled: nextMonthDisabled
    }
  };
};
